import React from "react";
import SiteComponent from "../../components/site/Site";
const Site = () => {
  return <SiteComponent />;
};

export default Site;
